import http from '@/plugins/axios';

export default {
  getUserList({ page, size, subType, queryType, queryValue }) {
    return http.get({
      url: `/admin/trade/user/sub/${page}/${size}`,
      data: {
        subType,
        queryType,
        queryValue
      }
    });
  },
  unBindSub({ id, subType, queryType, queryValue }) {
    return http.post({
      url: '/admin/trade/user/unBindSub',
      data: {
        id,
        subType: subType,
        queryType: queryType,
        queryValue: queryValue
      },
      dataType: 'form'
    });
  },
  addBindSub({ mainType, mainValue, subType, subValue }) {
    return http.post({
      url: '/admin/trade/user/bindSub',
      data: {
        mainType: mainType,
        mainValue: mainValue,
        subType: subType,
        subValue: subValue
      },
      dataType: 'form'
    });
  }
};
